import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { ConnectComponentsProvider, ConnectAccountManagement } from '@stripe/react-connect-js';
import api from '../utils/api';
import { toast } from 'sonner';
import { Card, CardContent } from './ui/card';
import StripeConnectBanner from './StripeConnectBanner';

const ProfileTab = () => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    try {
      const statusRes = await api.get('/organizations/stripe-connect/status');
      setStatus(statusRes.data);
      
      if (statusRes.data?.onboardingComplete) {
        await initializeStripe();
      }
    } catch (error) {
      console.error('Error checking status:', error);
    } finally {
      setLoading(false);
    }
  };

  const initializeStripe = async () => {
    try {
      const response = await api.post('/organizations/stripe-connect/account-session');
      const { clientSecret } = response.data;

      const instance = await loadConnectAndInitialize({
        publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
        fetchClientSecret: async () => {
          const res = await api.post('/organizations/stripe-connect/account-session');
          return res.data.clientSecret;
        },
        appearance: {
          variables: {
            colorPrimary: '#007AFF',
          },
        },
      });

      setStripeConnectInstance(instance);
    } catch (err) {
      console.error('Error initializing:', err);
      toast.error('Failed to load account settings');
    }
  };

  if (loading) {
    return (
      <Card>
        <CardContent className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
        </CardContent>
      </Card>
    );
  }

  if (!status?.onboardingComplete) {
    return <StripeConnectBanner />;
  }

  return (
    <Card className="border-2 border-gray-200">
      <CardContent className="p-6 min-h-[500px]">
        {stripeConnectInstance && (
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectAccountManagement />
          </ConnectComponentsProvider>
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileTab;
